import React from "react";
import "./Button.scss";

const Button = ({ label, onClick, type = "standard" }) => {
  return (
    <button className={`general-button-container ${type}`} onClick={onClick}>
      <div className="general-button-text">{label}</div>
    </button>
  );
};

export default Button;
